import { z } from "zod";
import { isValidPhoneNumber } from "react-phone-number-input";
import { format } from "date-fns";
import { eventTypeTypeValues } from "@ac-expo/api-types";

export const createWebEventSchema = z.object({
  name: z.string().min(1, "Le nom de l'événement est requis"),
  type: z.enum([...eventTypeTypeValues, ""]),
  place: z.string().min(1, "Le lieu est requis"),
  dates: z
    .object({
      from: z
        .date()
        .refine((date) => !isNaN(date.getTime()), "Date de début invalide"),
      to: z
        .date()
        .refine((date) => !isNaN(date.getTime()), "Date de fin invalide"),
    })
    .refine(
      (data) =>
        format(data.from, "yyyy-MM-dd") <= format(data.to, "yyyy-MM-dd"),
      {
        message: "La date de début doit être avant la date de fin",
        path: ["from"],
      }
    ),
  organiserEmail: z.string().email("Email invalide"),
  organiserPhone: z
    .string()
    .refine((phone) => isValidPhoneNumber(phone, "FR"), {
      message: "Téléphone invalide",
    }),
  entry: z
    .enum(["free", "paid"], {
      required_error: "Veuillez sélectionner un type d'entrée",
    })
    .default("free"),
  venue: z
    .object({
      indoor: z.boolean(),
      outdoor: z.boolean(),
    })
    .refine((data) => data.indoor || data.outdoor, {
      message: "Au moins un type de lieu doit être sélectionné",
    }),
});

export const defaultWebCreateEventValues = {
  name: "",
  type: undefined,
  place: undefined,
  dates: {
    from: new Date(),
    to: new Date(),
  },
  organiserEmail: "",
  organiserPhone: "",
  entry: "free" as const,
  venue: {
    indoor: false,
    outdoor: false,
  },
};

export type CreateWebEventForm = z.infer<typeof createWebEventSchema>;
